import { FormBase } from "../../../util/form-base-form";
import { Roles } from "../../../constants/roles";

export class ProductSortToggleForm extends FormBase {
    private root: HTMLElement;

    public constructor(root: HTMLElement) {
        super();
        this.root = root;
    }

    public getInput(): HTMLInputElement | null {
        return this.queryElement(
            this.root,
            `[data-role="${Roles.PRODUCT_SORT_TOGGLE_BTN}"]`,
            HTMLInputElement,
        );
    }
}
